import React, { useState } from 'react';
import Pagination, { Dot } from '@app/components/SliderHome/Pagination';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { makeNewBannerListWithoutDuplicate } from '@app/utils/theme';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import Image from 'next/image';
// import Image from './Image';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const WrapperDesktopSlider = /*#__PURE__*/styled("div")({
  name: "WrapperDesktopSlider",
  class: "w1bxxhj6"
});
const BannerWithVideo = /*#__PURE__*/styled("div")({
  name: "BannerWithVideo",
  class: "b1uhfkiz"
});
function DesktopSlider(props) {
  const {
    isMobile,
    bannerList,
    onClick,
    sliderTheme
  } = props;
  const [slideIndex, setSlideIndex] = useState(0);
  let currentIndex = 0;
  const isThemeSlider = sliderTheme?.items && sliderTheme?.items?.length > 0;
  const newBannerList = isThemeSlider ? makeNewBannerListWithoutDuplicate(bannerList, sliderTheme) : bannerList;
  const handleChangeSlideIndex = index => {
    setSlideIndex(index);
    currentIndex = index;
  };
  const handleClick = (item, index) => {
    if (currentIndex === Math.round(currentIndex)) {
      onClick(item, index + 1);
      setTimeout(() => {
        window.location.href = item.url || item.targetUrl;
      }, 300);
    }
  };
  const renderSliders = () => {
    const sliders = [];
    if (isThemeSlider) {
      sliderTheme.items.forEach((item, index) => {
        const isAutoPlay = slideIndex === index ? 1 : 0;
        sliders.push(<BannerWithVideo key={`img_theme_${index.toString()}`} onClick={() => handleClick(item)}>
            <Image alt="" className="img-item" width="100%" loading="lazy" height={isMobile ? 36 : 25} layout="responsive" unoptimized quality={95} objectFit="cover" src={`${isMobile && item.mobileImageUrl ? item.mobileImageUrl : item.imageUrl}`} />
            {item.videoUrl && <iframe title={item.name ? item.name : 'Slider'} width="300" height="168" src={`${item.videoUrl}?rel=0&amp;autoplay=${isAutoPlay}&mute=1&showinfo=0&controls=1&modestbranding=1`} frameBorder="0" />}
          </BannerWithVideo>);
      });
    }
    if (newBannerList && newBannerList.length > 0) {
      newBannerList.forEach((item, index) => {
        sliders.push(<Image key={`img_${item.id.toString()}`} alt={item.name} onClick={() => handleClick(item)} className="img-item" width="100%" unoptimized quality={95} priority={index === 0} height={isMobile ? 36 : 25} layout="responsive" objectFit="cover" src={`${isMobile ? item.mobileImage.replace('http://', '//') : item.desktopImage.replace('http://', '//')}`} />);
      });
    }
    return sliders;
  };
  const renderDots = () => {
    const dots = [];
    const sizeSlidersTheme = sliderTheme?.items?.length || 0;
    if (isThemeSlider) {
      sliderTheme.items.forEach((item, index) => {
        dots.push(<Dot key={'dot_theme_' + index.toString()} onClick={() => setSlideIndex(index)} className={slideIndex === index ? 'active' : ''} />);
      });
    }
    if (newBannerList && newBannerList.length > 0) {
      newBannerList.forEach((item, index) => {
        const orgIndex = index + sizeSlidersTheme;
        dots.push(<Dot key={'dot_' + orgIndex.toString()} onClick={() => setSlideIndex(orgIndex)} className={slideIndex === orgIndex ? 'active' : ''} />);
      });
    }
    return dots;
  };
  return <WrapperDesktopSlider>
      <AutoPlaySwipeableViews onSwitching={index => {
      setTimeout(() => {
        currentIndex = index;
      });
    }} enableMouseEvents index={slideIndex} onChangeIndex={handleChangeSlideIndex} interval={sliderTheme?.maxBannerVideoTime ? sliderTheme.maxBannerVideoTime * 1000 : 3000}>
        {renderSliders()}
      </AutoPlaySwipeableViews>

      <Pagination>{renderDots()}</Pagination>
    </WrapperDesktopSlider>;
}
export default DesktopSlider;

require("../../../.linaria-cache/src/components/SliderHome/Desktop.linaria.module.css");